import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { SdmTypography } from './';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import RemoveIcon from '@material-ui/icons/Remove';
import CheckIcon from '@material-ui/icons/Check';

import { theme } from '../theme';
import { styled } from '@material-ui/core/styles';

const StyledCheckbox = styled(Checkbox)({
  height: '18px !important',
  width: '18px !important',
  marginLeft: 11,
  '&.MuiCheckbox-colorSecondary.Mui-checked': {
    color: theme.colors.primary.red,
  },
  '&:hover': {
    backgroundColor: 'transparent !important',
  },
});
const StyledCheckboxOutline = styled(CheckBoxOutlineBlankIcon)(
  ({ variant }) => ({
    ...variant,
    width: 18,
    height: 18,
    margin: 3,
  })
);
const StyledCheckedIcon = styled(CheckIcon)({
  background: theme.colors.primary.red + '!important',
  color: 'white !important',
  width: 18,
  height: 18,
  margin: 3,
});

const StyledRemoveIcon = styled(RemoveIcon)({
  background: theme.colors.primary.red + '!important',
  color: 'white !important',
  width: 18,
  height: 18,
  margin: 3,
});

const CustomFormControlLabel = styled(FormControlLabel)({
  marginBottom: 16,
  paddingBottom: 0,
  color: 'black',
  fontWeight: 'bold',
  fontSize: 14,
});

const variants = {
  greyLight: {
    background: theme.colors.greyScale.backgroundGrey + ' !important',
    color: theme.colors.greyScale.backgroundGrey + ' !important',
  },
  grey: {
    background: theme.colors.greyScale.gray5 + ' !important',
    color: theme.colors.greyScale.gray5 + ' !important',
  },
  white: {
    background: 'white !important',
    color: 'white !important',
  },
};
/* eslint-disable */
export const SdmCheckbox = forwardRef(
  (
    {
      variant = 'grey',
      label,
      labelPlacement = 'top',
      isSelected = false,
      customFont = false,
      ...rest
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      customReset() {
        setChecked(false);
      },
    }));
    const [checked, setChecked] = useState(false);
    const checkboxRef = useRef(null);
    const handleChange = (e) => {
      setChecked(e.target.checked);
    };

    useEffect(() => {
      setChecked(isSelected);
    }, [isSelected]);

    return (
      <CustomFormControlLabel
        control={
          <StyledCheckbox
            onChange={handleChange}
            checked={checked}
            ref={checkboxRef}
            icon={<StyledCheckboxOutline variant={variants[variant]} />}
            checkedIcon={<StyledCheckedIcon />}
            indeterminateIcon={<StyledRemoveIcon />}
            {...rest}
            disableRipple
          />
        }
        label={
          <SdmTypography
            margin={0}
            style={{ paddingLeft: 10 }}
            variant={customFont || 'h2Regular'}
          >
            {label}
          </SdmTypography>
        }
        labelPlacement={labelPlacement}
      />
    );
  }
);
/* eslint-enabled */
